export const getTrajectoryColumnHeaderTKey = (field: string, useShortColumnHeaders: boolean): string =>
  useShortColumnHeaders ? `TableHeadersShort.${field}` : `TableHeaders.${field}`;
